/**
 * Ingestion state machine + source/connector vocabulary.
 *
 * Every value used in the DB goes through these constants so a typo in
 * one place doesn't silently break a comparison somewhere else. Add a
 * state only after updating the state machine diagram in the ingestion
 * FUNCTIONALITY.md.
 */
export const LOAN_FILE_STATE = {
    DRAFT: 'draft',
    RECEIVED: 'received',
    VIRUS_SCAN_PENDING: 'virus_scan_pending',
    VIRUS_SCANNED: 'virus_scanned',
    ACCEPTED: 'accepted',
    PARSING_IN_PROGRESS: 'parsing_in_progress',
    PARSED: 'parsed',
    PARSING_FAILED: 'parsing_failed',
    // Sprint 6 — validation
    VALIDATION_IN_PROGRESS: 'validation_in_progress',
    VALIDATED: 'validated',
    VALIDATION_FAILED: 'validation_failed',
    REJECTED: 'rejected',
};
/**
 * Allowed transitions. Enforced by transitionState() in @loanaudit/ingestion-core.
 *
 * Sprint 5 extended the machine past `accepted` through parsing:
 *   accepted → parsing_in_progress → parsed           (happy path)
 *                                  → parsing_failed    (OCR or LLM error)
 *
 * Sprint 6 extends past `parsed` through validation:
 *   parsed → validation_in_progress → validated           (all UCs ran OK)
 *                                    → validation_failed   (retriable)
 *   validation_failed → validation_in_progress            (retry)
 *   validated         → validation_in_progress            (manual re-validate)
 *   validated         → parsing_in_progress               (full re-parse resets chain)
 *
 * `rejected` remains reachable from every non-terminal state by the manual-reject route.
 */
export const LOAN_FILE_TRANSITIONS = {
    draft: ['received', 'rejected'],
    received: ['virus_scan_pending', 'rejected'],
    virus_scan_pending: ['virus_scanned', 'rejected'],
    virus_scanned: ['accepted', 'rejected'],
    accepted: ['parsing_in_progress', 'rejected'],
    parsing_in_progress: ['parsed', 'parsing_failed', 'rejected'],
    parsed: ['parsing_in_progress', 'validation_in_progress', 'rejected'],
    parsing_failed: ['parsing_in_progress', 'rejected'],
    validation_in_progress: ['validated', 'validation_failed', 'rejected'],
    validated: ['validation_in_progress', 'parsing_in_progress', 'rejected'],
    validation_failed: ['validation_in_progress', 'parsing_in_progress', 'rejected'],
    rejected: ['received'],
};
export const INGESTION_SOURCE = {
    UPLOAD: 'upload', // web UI
    API_PUSH: 'api_push', // upstream LOS/DMS push to our API
    CONNECTOR: 'connector', // scheduled pull (qualified as "connector:<key>")
};
export const DOCUMENT_UPLOAD_STATE = {
    PENDING: 'pending',
    UPLOADED: 'uploaded',
    FAILED: 'failed',
};
export const DOCUMENT_SCAN_STATE = {
    PENDING: 'pending',
    CLEAN: 'clean',
    INFECTED: 'infected',
    ERROR: 'error',
};
/**
 * Built-in connector registry keys. Real LOS/DMS connectors ship later.
 * Use MOCK_LOS for local testing — it reads from an S3 folder.
 */
export const CONNECTOR_KEY = {
    MOCK_LOS: 'mock_los',
};
//# sourceMappingURL=ingestion.js.map